import { FC } from "react";
import CardImageWrap from "../../../Card/components/CardImageWrap/component";
import { getImageProps } from "./utils";
import { CardVariantsEnum } from "../../../../utils/dataTransform/ContentQueryWidget/types";
import { NULL_COMPONENTS_BY_VARIANT } from "../../../../utils/dataTransform/ContentQueryWidget/constants";

export const DEFAULT_IMAGE_URL =
    "https://i.cbc.ca/1.1942741.1381638556!/httpImage/image.jpg_gen/derivatives/16x9_1180/hi-cbc-logo.jpg?im=";

export interface CardThumbnailProps {
    variant: CardVariantsEnum;
    image?: CardThumbnailImage;
    videoCardOverlayType?: string;
    videoDuration?: number;
    videoAirDate?: number;
    videoHasCaptions?: boolean;
    videoStreamType?: string;
}

export interface CardThumbnailImage {
    url?: string;
    srcset?: string[];
}

export const shouldRenderFallBackImage = (
    variant: CardVariantsEnum
): boolean => {
    return NULL_COMPONENTS_BY_VARIANT[variant].imageURL !== null;
};

const CardThumbnail: FC<CardThumbnailProps> = ({
    image,
    videoCardOverlayType,
    variant,
    videoDuration,
    videoAirDate,
    videoHasCaptions,
    videoStreamType,
}) => {
    if (!image) return null;

    const thumbnailImage = { ...image };

    // If no image.url prop provided, we need to check to see if we should set a default image
    // We will check the NULL_PROPS_BY_VARIANT object to determine if we should render a fallback image
    if (!thumbnailImage.url) {
        if (shouldRenderFallBackImage(variant)) {
            thumbnailImage.url = DEFAULT_IMAGE_URL;
        } else {
            return null;
        }
    }

    const videoLinkImageOverlayProps = {
        videoCardOverlayType: videoCardOverlayType ?? null,
        videoDuration: videoDuration ?? null,
        videoAirDate: Number(videoAirDate) ?? null,
        videoHasCaptions: videoHasCaptions,
        videoStreamType: videoStreamType,
    };

    return (
        <div className="card-cqw-image-top" data-testid="card-cqw-image-top">
            <CardImageWrap
                {...{
                    imageProps: getImageProps(thumbnailImage, variant),
                    videoLinkImageOverlayProps,
                }}
            />
        </div>
    );
};

export default CardThumbnail;
